(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['module', './utils/error'], factory);
    } else if (typeof exports !== "undefined") {
        factory(module, require('./utils/error'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.error);
        global.index = mod.exports;
    }
})(this, function (module, _error) {
    'use strict';

    var _error2 = _interopRequireDefault(_error);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
        "use strict";

        if (!Function.prototype.$asyncbind) {
            Object.defineProperty(Function.prototype, "$asyncbind", {
                value: $asyncbind,
                enumerable: false,
                configurable: true,
                writable: true
            });
        }

        if (!$asyncbind.trampoline) {
            $asyncbind.trampoline = function trampoline(t, x, s, e, u) {
                return function b(q) {
                    while (q) {
                        if (q.then) {
                            q = q.then(b, e);
                            return u ? undefined : q;
                        }

                        try {
                            if (q.pop) {
                                if (q.length) return q.pop() ? x.call(t) : q;
                                q = s;
                            } else q = q.call(t);
                        } catch (r) {
                            return e(r);
                        }
                    }
                };
            };
        }

        if (!$asyncbind.LazyThenable) {
            $asyncbind.LazyThenable = function () {
                function isThenable(obj) {
                    return obj && obj instanceof Object && typeof obj.then === "function";
                }

                function resolution(p, r, how) {
                    try {
                        var x = how ? how(r) : r;
                        if (p === x) return p.reject(new TypeError("Promise resolution loop"));

                        if (isThenable(x)) {
                            x.then(function (y) {
                                resolution(p, y);
                            }, function (e) {
                                p.reject(e);
                            });
                        } else {
                            p.resolve(x);
                        }
                    } catch (ex) {
                        p.reject(ex);
                    }
                }

                function _unchained(v) {}

                function thenChain(res, rej) {
                    this.resolve = res;
                    this.reject = rej;
                }

                function Chained() {}

                ;
                Chained.prototype = {
                    resolve: _unchained,
                    reject: _unchained,
                    then: thenChain
                };

                function then(res, rej) {
                    var chain = new Chained();

                    try {
                        this._resolver(function (value) {
                            return isThenable(value) ? value.then(res, rej) : resolution(chain, value, res);
                        }, function (ex) {
                            resolution(chain, ex, rej);
                        });
                    } catch (ex) {
                        resolution(chain, ex, rej);
                    }

                    return chain;
                }

                function Thenable(resolver) {
                    this._resolver = resolver;
                    this.then = then;
                }

                ;

                Thenable.resolve = function (v) {
                    return Thenable.isThenable(v) ? v : {
                        then: function (resolve) {
                            return resolve(v);
                        }
                    };
                };

                Thenable.isThenable = isThenable;
                return Thenable;
            }();

            $asyncbind.EagerThenable = $asyncbind.Thenable = ($asyncbind.EagerThenableFactory = function (tick) {
                tick = tick || typeof process === "object" && process.nextTick || typeof setImmediate === "function" && setImmediate || function (f) {
                    setTimeout(f, 0);
                };

                var soon = function () {
                    var fq = [],
                        fqStart = 0,
                        bufferSize = 1024;

                    function callQueue() {
                        while (fq.length - fqStart) {
                            try {
                                fq[fqStart]();
                            } catch (ex) {}

                            fq[fqStart++] = undefined;

                            if (fqStart === bufferSize) {
                                fq.splice(0, bufferSize);
                                fqStart = 0;
                            }
                        }
                    }

                    return function (fn) {
                        fq.push(fn);
                        if (fq.length - fqStart === 1) tick(callQueue);
                    };
                }();

                function Zousan(func) {
                    if (func) {
                        var me = this;
                        func(function (arg) {
                            me.resolve(arg);
                        }, function (arg) {
                            me.reject(arg);
                        });
                    }
                }

                Zousan.prototype = {
                    resolve: function (value) {
                        if (this.state !== undefined) return;
                        if (value === this) return this.reject(new TypeError("Attempt to resolve promise with self"));
                        var me = this;

                        if (value && (typeof value === "function" || typeof value === "object")) {
                            try {
                                var first = 0;
                                var then = value.then;

                                if (typeof then === "function") {
                                    then.call(value, function (ra) {
                                        if (!first++) {
                                            me.resolve(ra);
                                        }
                                    }, function (rr) {
                                        if (!first++) {
                                            me.reject(rr);
                                        }
                                    });
                                    return;
                                }
                            } catch (e) {
                                if (!first) this.reject(e);
                                return;
                            }
                        }

                        this.state = STATE_FULFILLED;
                        this.v = value;
                        if (me.c) soon(function () {
                            for (var n = 0, l = me.c.length; n < l; n++) STATE_FULFILLED(me.c[n], value);
                        });
                    },
                    reject: function (reason) {
                        if (this.state !== undefined) return;
                        this.state = STATE_REJECTED;
                        this.v = reason;
                        var clients = this.c;
                        if (clients) soon(function () {
                            for (var n = 0, l = clients.length; n < l; n++) STATE_REJECTED(clients[n], reason);
                        });
                    },
                    then: function (onF, onR) {
                        var p = new Zousan();
                        var client = {
                            y: onF,
                            n: onR,
                            p: p
                        };

                        if (this.state === undefined) {
                            if (this.c) this.c.push(client);else this.c = [client];
                        } else {
                            var s = this.state,
                                a = this.v;
                            soon(function () {
                                s(client, a);
                            });
                        }

                        return p;
                    }
                };

                function STATE_FULFILLED(c, arg) {
                    if (typeof c.y === "function") {
                        try {
                            var yret = c.y.call(undefined, arg);
                            c.p.resolve(yret);
                        } catch (err) {
                            c.p.reject(err);
                        }
                    } else c.p.resolve(arg);
                }

                function STATE_REJECTED(c, reason) {
                    if (typeof c.n === "function") {
                        try {
                            var yret = c.n.call(undefined, reason);
                            c.p.resolve(yret);
                        } catch (err) {
                            c.p.reject(err);
                        }
                    } else c.p.reject(reason);
                }

                Zousan.resolve = function (val) {
                    if (val && val instanceof Zousan) return val;
                    var z = new Zousan();
                    z.resolve(val);
                    return z;
                };

                Zousan.reject = function (err) {
                    if (err && err instanceof Zousan) return err;
                    var z = new Zousan();
                    z.reject(err);
                    return z;
                };

                Zousan.version = "2.3.3-nodent";
                return Zousan;
            })();
        }

        function boundThen() {
            return resolver.apply(self, arguments);
        }

        var resolver = this;

        switch (catcher) {
            case true:
                return new $asyncbind.Thenable(boundThen);

            case 0:
                return new $asyncbind.LazyThenable(boundThen);

            case undefined:
                boundThen.then = boundThen;
                return boundThen;

            default:
                return function () {
                    try {
                        return resolver.apply(self, arguments);
                    } catch (ex) {
                        return catcher(ex);
                    }
                };
        }
    };

    var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    // all keys stored in the cache by this SDK will be prefixed with this value
    const CACHE_PREFIX = 'notification:';

    // cached for 1 minute
    const CACHE_DURATION = 1;

    function SDK(baseUrl, fetch, cacheInterface) {
        function _fetchJson(url, options = {}) {
            return new Promise(function ($return, $error) {
                if (options && options.body) {
                    options.headers = _extends({}, options.headers || {}, {
                        ['content-type']: 'application/json'
                    });
                }

                // some of the sdks are used in the browser where the native fetch is used.
                if (typeof window === 'undefined') {
                    options.responseType = 'json';

                    var $Try_1_Post = function () {
                        return $If_2.call(this);
                    }.$asyncbind(this, $error);

                    var $Try_1_Catch = function (error) {
                        let data;
                        data = error.response.body;

                        throw _extends({
                            status: error.statusCode
                        }, data);
                    }.$asyncbind(this, $error);

                    try {
                        let res;
                        return fetch(`${baseUrl}${url}`, options).then(function ($await_5) {
                            res = $await_5;

                            return $return(res.body);
                        }.$asyncbind(this, $Try_1_Catch), $Try_1_Catch);
                    } catch (error) {
                        $Try_1_Catch(error)
                    }
                } else {
                    let res;
                    return fetch(`${baseUrl}${url}`, options).then(function ($await_6) {
                        res = $await_6;

                        if (res.ok) {
                            return res.json().then($return, $error);
                        } else {
                            let text;

                            if (res.headers.get('Content-Type').indexOf('application/json') !== -1) {
                                let json;
                                return res.json().then(function ($await_8) {
                                    json = $await_8;

                                    return $error(new _error2.default(res.status, res.statusText, json.message));
                                }.$asyncbind(this, $error), $error);
                            }
                            return res.text().then(function ($await_9) {
                                text = $await_9;

                                return $error(text);
                            }.$asyncbind(this, $error), $error);
                        }
                        return $If_2.call(this);
                    }.$asyncbind(this, $error), $error);
                }

                function $If_2() {
                    return $return();
                }
            });
        }

        const _cacheGet = key => cacheInterface.get(`${CACHE_PREFIX}${key}`);
        const _cacheSet = (key, value, ttl) => cacheInterface.set(`${CACHE_PREFIX}${key}`, value, ttl);
        // const _cacheRemove = ( key ) => cacheInterface.remove( `${ CACHE_PREFIX }${ key }` );
        const _cacheClear = () => cacheInterface.clear();

        return {
            ping: () => new Promise(function ($return, $error) {
                return $return(_fetchJson('/ping'));
            }),
            version: () => new Promise(function ($return, $error) {
                return $return(_fetchJson('/version'));
            }),
            health: () => new Promise(function ($return, $error) {
                return $return(_fetchJson('/health'));
            }),

            getComponents: () => new Promise(function ($return, $error) {
                let cached, response;
                cached = _cacheGet('notification-components');

                if (cached) {
                    return $return(cached);
                }

                return _fetchJson('/components').then(function ($await_10) {
                    response = $await_10;

                    if (!response.components) {
                        response = { components: response };
                    }

                    return $return(_cacheSet('notification-components', response, CACHE_DURATION));
                }.$asyncbind(this, $error), $error);
            }),
            getComponentsByNotificationId: notificationId => new Promise(function ($return, $error) {
                let cached, response;
                cached = _cacheGet('notification-components-by-notification-id');

                if (cached) {
                    return $return(cached);
                }

                return _fetchJson(`/components?notificationId=${notificationId}`).then(function ($await_11) {
                    response = $await_11;
                    if (!response.components) {
                        response = { components: response };
                    }

                    return $return(_cacheSet('notification-components-by-notification-id', response, CACHE_DURATION));
                }.$asyncbind(this, $error), $error);
            }),
            getComponentsByMediumId: mediumId => new Promise(function ($return, $error) {
                let cached, response;
                cached = _cacheGet('notification-components-by-medium-id');

                if (cached) {
                    return $return(cached);
                }

                return _fetchJson(`/components?deliveryMediumId=${mediumId}`).then(function ($await_12) {
                    response = $await_12;
                    if (!response.components) {
                        response = { components: response };
                    }

                    return $return(_cacheSet('notification-components-by-medium-id', response, CACHE_DURATION));
                }.$asyncbind(this, $error), $error);
            }),
            createComponent: component => new Promise(function ($return, $error) {
                let response;
                return _fetchJson('/components', {
                    method: 'POST',
                    body: JSON.stringify(component)
                }).then(function ($await_13) {
                    response = $await_13;


                    _cacheClear();
                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),
            updateComponent: component => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/components/${encodeURIComponent(component.id)}`, {
                    method: 'PUT',
                    body: JSON.stringify(component)
                }).then(function ($await_14) {
                    response = $await_14;


                    _cacheClear();
                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),
            deleteComponent: id => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/components/${encodeURIComponent(id)}`, {
                    method: 'DELETE'
                }).then(function ($await_15) {
                    response = $await_15;


                    _cacheClear();
                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            getDictionaries: () => new Promise(function ($return, $error) {
                let cached, response;
                cached = _cacheGet('notification-dictionaries');

                if (cached) {
                    return $return(cached);
                }

                return _fetchJson('/dictionaries').then(function ($await_16) {
                    response = $await_16;


                    return $return(_cacheSet('notification-dictionaries', response, CACHE_DURATION));
                }.$asyncbind(this, $error), $error);
            }),

            getComponentTemplates: () => new Promise(function ($return, $error) {
                let cached, response;
                cached = _cacheGet('notification-layout-components');

                if (cached) {
                    return $return(cached);
                }

                return _fetchJson('/component-templates').then(function ($await_17) {
                    response = $await_17;

                    if (!response.componentTemplates) {
                        response = { componentTemplates: response };
                    }

                    return $return(_cacheSet('notification-layout-components', response, CACHE_DURATION));
                }.$asyncbind(this, $error), $error);
            }),

            getNotifications: () => new Promise(function ($return, $error) {
                let cached, response;
                cached = _cacheGet('notification-notifications');

                if (cached) {
                    return $return(cached);
                }

                return _fetchJson('/notifications').then(function ($await_18) {
                    response = $await_18;

                    return $return(_cacheSet('notification-notifications', response, CACHE_DURATION));
                }.$asyncbind(this, $error), $error);
            }),
            getNotificationById: id => new Promise(function ($return, $error) {
                let cached, response;
                cached = _cacheGet('notification-notification-by-id');

                if (cached) {
                    return $return(cached);
                }

                return _fetchJson(`/notifications/${id}`).then(function ($await_19) {
                    response = $await_19;


                    return $return(_cacheSet('notification-notification-by-id', response, CACHE_DURATION));
                }.$asyncbind(this, $error), $error);
            }),
            createNotification: (notification, triggerId) => new Promise(function ($return, $error) {
                let response;
                return _fetchJson('/notifications', {
                    method: 'POST',
                    body: JSON.stringify(notification)
                }).then(function ($await_20) {
                    response = $await_20;


                    _cacheClear();
                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),
            updateNotification: notification => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/notifications/${encodeURIComponent(notification.id)}`, {
                    method: 'PUT',
                    body: JSON.stringify(notification)
                }).then(function ($await_21) {
                    response = $await_21;


                    _cacheClear();
                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),
            deleteNotification: id => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/notifications/${encodeURIComponent(id)}`, {
                    method: 'DELETE'
                }).then(function ($await_22) {
                    response = $await_22;


                    _cacheClear();
                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            sendStudio: (companyId, triggerName, recipients, notificationId, emailMetadata) => new Promise(function ($return, $error) {
                let response;
                return _fetchJson('/send/studio', {
                    method: 'POST',
                    body: JSON.stringify({ companyId: companyId, triggerName: triggerName, recipients: recipients, notificationId: notificationId, emailMetadata: emailMetadata })
                }).then(function ($await_23) {
                    response = $await_23;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            send: (companyId, triggerName, application, recipientPersonId, properties, metadata) => new Promise(function ($return, $error) {
                let timestamp, response;
                timestamp = Date.now();
                return _fetchJson('/send', {
                    method: 'POST',
                    body: { timestamp, application, companyId, triggerName, recipientPersonId, properties, metadata }
                }).then(function ($await_24) {
                    response = $await_24;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            getTriggers: () => new Promise(function ($return, $error) {
                let response;
                return _fetchJson('/triggers', {
                    method: 'GET'
                }).then(function ($await_25) {
                    response = $await_25;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            searchTriggers: (name, categories, notificationId) => new Promise(function ($return, $error) {
                let query, queryString, response;
                query = [];

                if (name) {
                    query.push(`name=${encodeURIComponent(name)}`);
                }
                if (categories) {
                    query.push(`categories=${encodeURIComponent(categories)}`);
                }
                if (notificationId) {
                    query.push(`notificationId=${encodeURIComponent(notificationId)}`);
                }
                queryString = query.join('&');
                return _fetchJson(`/triggers/search?${queryString}`, {
                    method: 'GET'
                }).then(function ($await_26) {
                    response = $await_26;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            getTrigger: id => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/triggers/${encodeURIComponent(id)}`, {
                    method: 'GET'
                }).then(function ($await_27) {
                    response = $await_27;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            createTrigger: (name, category) => new Promise(function ($return, $error) {
                let response;
                return _fetchJson('/triggers', {
                    method: 'POST',
                    body: JSON.stringify({ name, category })
                }).then(function ($await_28) {
                    response = $await_28;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            updateTrigger: (id, name, category) => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/triggers/${encodeURIComponent(id)}`, {
                    method: 'PUT',
                    body: JSON.stringify({ name, category })
                }).then(function ($await_29) {
                    response = $await_29;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            deleteTrigger: id => new Promise(function ($return, $error) {
                return _fetchJson(`/triggers/${encodeURIComponent(id)}`, {
                    method: 'DELETE'
                }).then(function ($await_30) {

                    return $return(true);
                }.$asyncbind(this, $error), $error);
            }),

            getTriggerContexts: id => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/triggers/${encodeURIComponent(id)}/triggercontexts`, {
                    method: 'GET'
                }).then(function ($await_31) {
                    response = $await_31;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            getTriggerContext: (triggerId, contextId) => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/triggers/${encodeURIComponent(triggerId)}/triggercontexts/${encodeURIComponent(contextId)}`, {
                    method: 'GET'
                }).then(function ($await_32) {
                    response = $await_32;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            createTriggerContext: (triggerId, context) => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/triggers/${encodeURIComponent(triggerId)}/triggercontexts`, {
                    method: 'POST',
                    body: JSON.stringify(context)
                }).then(function ($await_33) {
                    response = $await_33;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            updateTriggerContext: (triggerId, contextId, context) => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/triggers/${encodeURIComponent(triggerId)}/triggercontexts/${contextId}`, {
                    method: 'PUT',
                    body: JSON.stringify(context)
                }).then(function ($await_34) {
                    response = $await_34;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            deleteTriggerContext: (triggerId, contextId) => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/triggers/${encodeURIComponent(triggerId)}/triggercontexts/${contextId}`, {
                    method: 'DELETE'
                }).then(function ($await_35) {
                    response = $await_35;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            getTriggerHierarchies: triggerId => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/triggers/${triggerId}/hierarchies`, {
                    method: 'GET'
                }).then(function ($await_36) {
                    response = $await_36;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            getTriggerHierarchy: (triggerId, hierarchyId) => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/triggers/${triggerId}/hierarchies/${hierarchyId}`, {
                    method: 'GET'
                }).then(function ($await_37) {
                    response = $await_37;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            createTriggerHierarchy: (triggerId, hierarchy) => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/triggers/${triggerId}/hierarchies`, {
                    method: 'POST',
                    body: JSON.stringify(_extends({}, hierarchy))
                }).then(function ($await_38) {
                    response = $await_38;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            editTriggerHierarchy: (triggerId, hierarchyId, hierarchy) => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/triggers/${triggerId}/hierarchies/${hierarchyId}`, {
                    method: 'PUT',
                    body: JSON.stringify(_extends({}, hierarchy))
                }).then(function ($await_39) {
                    response = $await_39;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            deleteTriggerHierarchy: (triggerId, hierarchyId) => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/triggers/${triggerId}/hierarchies/${hierarchyId}`, {
                    method: 'DELETE'
                }).then(function ($await_40) {
                    response = $await_40;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            createTriggerNotificationSelection: (notificationId, triggerId, hierarchyId, discriminatorValue) => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/triggers/${triggerId}/hierarchies/${hierarchyId}/selections`, {
                    method: 'POST',
                    body: JSON.stringify({
                        discriminatorValue,
                        notificationId
                    })
                }).then(function ($await_41) {
                    response = $await_41;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            searchNotificationSelections: (notificationId, triggerId) => new Promise(function ($return, $error) {
                let query, queryString, response;
                query = [];

                if (notificationId) {
                    query.push(`notificationId=${encodeURIComponent(notificationId)}`);
                }
                if (triggerId) {
                    query.push(`triggerId=${encodeURIComponent(triggerId)}`);
                }
                queryString = query.join('&');
                return _fetchJson(`/selections/search?${queryString}`, {
                    method: 'GET'
                }).then(function ($await_42) {
                    response = $await_42;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            deleteNotificationHierarchy: (triggerId, hierarchyId) => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/triggers/${triggerId}/hierarchies/${hierarchyId}`, {
                    method: 'DELETE'
                }).then(function ($await_43) {
                    response = $await_43;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            deleteNotificationSelection: (triggerId, hierarchyId, selectionId) => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/triggers/${triggerId}/hierarchies/${hierarchyId}/selections/${selectionId}`, {
                    method: 'DELETE'
                }).then(function ($await_44) {
                    response = $await_44;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            createDeliveryMedium: (medium, notificationId) => new Promise(function ($return, $error) {
                let response;
                return _fetchJson('/deliverymediums', {
                    method: 'POST',
                    body: JSON.stringify(_extends({}, medium, {
                        notificationId
                    }))
                }).then(function ($await_45) {
                    response = $await_45;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            updateDeliveryMedium: (id, medium) => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/deliverymediums/${id}`, {
                    method: 'PUT',
                    body: JSON.stringify(_extends({}, medium))
                }).then(function ($await_46) {
                    response = $await_46;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            }),

            deleteDeliveryMedium: id => new Promise(function ($return, $error) {
                let response;
                return _fetchJson(`/deliverymediums/${id}`, {
                    method: 'DELETE'
                }).then(function ($await_47) {
                    response = $await_47;


                    return $return(response);
                }.$asyncbind(this, $error), $error);
            })

        };
    }

    const noCache = {
        get: () => undefined,
        set: (key, value, lifetimeMins) => value,
        remove: key => undefined,
        clear: () => undefined
    };

    module.exports = function (url, customFetch, cacheInterface = noCache) {
        if (typeof customFetch !== 'function') {
            throw new Error(`${typeof customFetch} is not a function`);
        }

        return new SDK(url, customFetch, cacheInterface);
    };
});
//# sourceMappingURL=index.js.map